.page {
	display: grid;
	height: 100%;
	justify-content: center;
	align-items: start;
	padding-block: var(--size-10);
	isolation: isolate;
	background-color: var(--color-primary);

	&::before {
		content: "";
		position: fixed;
		inset: 0;
		z-index: -1;
		background: linear-gradient(rgb(from var(--gray-100) r g b / 30%), transparent);
		mask: url("../texture.svg") center / max(4912px, hypot(100vw, 100vh) * 1.11) no-repeat;
	}
}

.content {
	width: 24rem;
	margin-top: max(0px, -300px + 50svh);
	display: grid;
	justify-items: center;
	gap: var(--size-5);
	background-color: var(--color-background);
	border-radius: var(--radius-xl);
	padding: var(--size-10) var(--size-8) var(--size-8);
	box-shadow: var(--shadow-lg);
}

.title {
	margin-block: var(--size-5);
	text-align: center;
	font-size: var(--text-subtitle-1);
}

.main {
	width: 100%;
}

.body {
	display: flex;
	flex-direction: column;
	gap: var(--size-5);
	padding: var(--size-5) var(--size-5) 0;
	text-wrap: pretty;
}

.footerPrompt {
	text-align: center;
}
